import React from 'react';
import YouTube from 'react-youtube';

function fullWidthTrend(props) {
  return (
  <div className="full-width-trend">
    {/* <img src={props.image.url} alt={props.image.alt} /> */}
    <YouTube
      containerClassName={'embed-responsive embed-responsive-16by9'}
      className={'embed-responsive-item'}  
      videoId={props.video_id}
    />    
    {/* <div className="full-width-trend__content">
      <h3>{props.title}</h3>
      <h4>{props.sub_heading}</h4>
    </div> */}
  </div>
  )
}

export default fullWidthTrend